module.exports = __webpack_public_path__ + "img/Icon_Upload.1f6c14bd.svg";